import {
  HomeWorkoutSequence,
  UserProfile,
} from 'fitbeat.gym-core';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {
  displayMusicScreenSelector,
  homeWorkoutSessionSelector,
  IAppStore,
  MusicPlayer,
  PlaylistSelectScreen,
} from '../../index';
import { GenericMusicPlayer } from './GenericMusicPlayer';
import { MusicSpotifyOnBoarding } from './MusicSpotifyOnBoarding';
import { SelectMusicSourceScreen } from './SelectMusicSourceScreen';

interface IProps {
  homeWorkoutSession: HomeWorkoutSequence | null;
  userProfile: UserProfile | null;
  displayMusicScreen: MusicScreens;
  t: (key: string, options?: any) => string;
}

export enum MusicScreens {
  GenericMusicPlayer = 'GenericMusicPlayer',
  MusicSourceSelect = 'MusicSourceSelect',
  PlaylistSelect = 'PlaylistSelectScreen',
  MusicPlayer = 'MusicPlayer',
  MusicSpotifyOnBoarding = 'MusicSpotifyOnBoarding',
}

const Music = ({
                 t,
                 homeWorkoutSession,
                 userProfile,
                 displayMusicScreen,
               }) => {

  switch (displayMusicScreen) {
    case MusicScreens.GenericMusicPlayer:
      return <GenericMusicPlayer t={t} />;
    case MusicScreens.MusicPlayer:
      return <MusicPlayer t={t} />;
    case MusicScreens.PlaylistSelect:
      return <PlaylistSelectScreen t={t} />;
    case MusicScreens.MusicSpotifyOnBoarding:
      return <MusicSpotifyOnBoarding t={t}/>;
    default:
      return <SelectMusicSourceScreen t={t} userProfile={userProfile} homeWorkoutSession={homeWorkoutSession} />;
  }
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({
  homeWorkoutSession: homeWorkoutSessionSelector(state),
  userProfile: state.homeWorkouts.userProfile,
  displayMusicScreen: displayMusicScreenSelector(state),
});

export const MusicSetup = connect(mapStateToProps)(
  translate(['homeWorkouts'])(Music));
